export default __webpack_public_path__ + "static/media/ic_dodo.56802cbe.svg";